<!-- passwordReset -->
<template>
  <div style="border: 0px solid red; height:100%;">
    <div class="modal-container-company" style="height:100%;width:100%;background: white;">
      <!-- Dialog标题 -->
      <div class="modal-header">
        <div style="width:50%;">{{$t('MODULE.PASSWORDRESET_DIALOG_TITLE')}}</div>
        <div style="width:50%; padding-right:5px" align='right'>
          <el-button type="text" class="el-icon-close" style="color:white;" @click="back_click"></el-button>
        </div>
      </div>
      <el-container style="padding: 0px; width: 100%;height:100%;">
        <el-main>
          <div align='center'>
            <!-- 文字 -->
            <div align='center' class="passwordReset_msg">
              <p v-html="$t('MODULE.PASSWORDRESET_MSG_MSG')"></p>
              <p v-html="$t('MODULE.PASSWORDRESET_MSG_MSG1')"></p>
            </div>
            <!-- パスワードリセットボタン -->
            <div style='padding:0px 0px 15px 0px;'>
              <el-button class="passwordReset-button1 css-btn" @click="resetClick" type="primary" v-html="$t('MODULE.PASSWORDRESET_BUTTON_NAME')"></el-button>
            </div>
            <!-- 文字 -->
            <div>
              <p style="font-size:15px;" v-html="$t('MODULE.PASSWORDRESET_MSG_MSG4')"></p>
            </div>
            <div style='padding:0px 0px 15px 0px;'>
              <!-- 問合せ連絡先(オフィス事務センター)ボタン -->
              <el-button @click="k0008ButtonClick" class="passwordReset-button1 css-btn" type="primary" v-html="$t('MODULE.PASSWORDRESET_BUTTON_NAME1')"></el-button>
            </div>
            <PasswordResetDeliver :visible.sync="showPasswordResetDeliverDialog" v-if="showPasswordResetDeliverDialog" :showK0008Dialog="showK0008Dialog" @closePasswordResetDeliverDialog="closePasswordResetDeliverDialog" @submitPasswordResetDeliverDialog="submitPasswordResetDeliverDialog"></PasswordResetDeliver>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>

let url = require('@/../config/sysConfig')
import PasswordResetDeliver from '@/components/page/passwordResetDeliver'
export default {
  components: {
    "PasswordResetDeliver": PasswordResetDeliver,
  },
  data() {
    return {
      showPasswordResetDeliverDialog: false,
      showK0008Dialog: false
    };
  },
  mounted() {

  },
  methods: {
    // 戻る処理
    back_click() {
      this.$emit('closepasswordResetDialog');
    },
    resetClick() {
      this.showK0008Dialog = false
      this.showPasswordResetDeliverDialog = true
    },
    closePasswordResetDeliverDialog() {
      this.showPasswordResetDeliverDialog = false
    },
    submitPasswordResetDeliverDialog() {
      this.showPasswordResetDeliverDialog = false
      this.$emit('closepasswordResetDialog');
    },
    k0008ButtonClick() {
      this.showK0008Dialog = true
      this.showPasswordResetDeliverDialog = true
    },
  },
  created() {

  },
};
</script>
<style scope>
/* パスワードリセットボタン */
/* 問合せ連絡先(オフィス事務センター)ボタン */
.passwordReset-button1 {
  width: 53%;
  height: 60px;
  padding: 0px;
  background-image: linear-gradient(0deg, #3cc6fa, #23b2e8);
  font-size: 10pt;
}
/* 第一段文字样式 */
.passwordReset_msg1 {
  font-size: 20px;
}
/* 第二段文字样式 */
.passwordReset_msg2 {
  font-size: 15px;
  color: red;
}
.passwordReset_msg h1 {
  margin: 15px 0;
}
/*pop様式*/
.m0004tab_btn_pop {
  margin-bottom: 10px;
  padding: 10px 20px;
}
.passwordReset_pop .el-dialog__title {
  background-color: none;
  color: #ffffff;
  font-size: 12pt;
  margin-left: 10px;
}
.passwordReset_pop .el-dialog__header {
  background-color: none;
  padding: 5px;
  background-image: linear-gradient(#464646, #717171);
  border-radius: 5px 5px 0 0;
  text-align: left;
}
.passwordReset_pop .el-dialog {
  border-radius: 5px;
  width: 100%;
  height: 100%;
}

.passwordReset_pop .el-dialog__body {
  padding: 5px;
}
.passwordReset_pop .el-icon-close:before {
  color: #ffffff;
  position: absolute;
  font-size: 14px;
  top: -10px;
  right: -10px;
}
.passwordReset_pop .dialog-fade-enter-active {
  animation: none !important;
}
.passwordReset_pop .dialog-fade-leave-active {
  animation: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/page/passwordReset.vue